import React from "react";
import { Card, CardBody, CardHeader, Badge } from "reactstrap";
import { Users, Award } from "react-feather";

import ResultBar from "./ResultBar";

/**
 * props:
 *  - title           : "User Poll" | "Panel Poll"
 *  - icon            : "users" | "panel" (controls the header icon)
 *  - options         : [{ id, label }]
 *  - votes           : { [optionId]: count }
 *  - correctOptionId : id of the correct option, to highlight
 */
const PollResult = ({ title, icon, options, votes, correctOptionId }) => {
  const total = options.reduce((sum, opt) => sum + (votes[opt.id] || 0), 0);

  return (
    <Card className="border-0 shadow-sm h-100">
      <CardHeader className="bg-white border-0 pt-3 pb-0 d-flex align-items-center justify-content-between">
        <span className="fw-bold fs-4">
          {icon === "panel" ? (
            <Award size={18} className="me-2 text-primary" />
          ) : (
            <Users size={18} className="me-2 text-primary" />
          )}
          {title}
        </span>

        <Badge color="light" className="text-dark border">
          {total} responses
        </Badge>
      </CardHeader>

      <CardBody>
        {options.map((opt) => {
          const count = votes[opt.id] || 0;
          const percent = total > 0 ? (count / total) * 100 : 0;

          return (
            <ResultBar
              key={opt.id}
              label={opt.label}
              count={count}
              percent={percent}
              isCorrect={opt.id === correctOptionId}
            />
          );
        })}

        <div className="text-end text-muted small mt-3">
          Total Responses: <strong>{total}</strong>
        </div>
      </CardBody>
    </Card>
  );
};

export default PollResult;
